export enum ApiErrors {
  AssembleiaNaoIniciou = 'EVNOTINI01',
  AssembleiaEncerrada = 'EVNCLOSE01',
  PautaNaoLiberadaParaVotacao = 'PANOTOPN01',
  UsuarioSemAcesso = 'USNOTLOG01',
}

export enum ApiName {
  Assessor = 'assessor',
  Notificacao = 'notificacao',
  Evento = 'evento',
  Pessoa = 'pessoa',
  Messenger = 'messenger',
}
